import { Workbox } from 'workbox-window'

let wb: Workbox | null = null
let updatePromptShown = false // 防重复弹窗标记（页面级）
const RELOAD_ON_CONTROL_KEY = 'sw-reload-on-control' // 仅在用户确认更新后触发一次刷新

export const registerSW = async () => {
  // 检查是否支持Service Worker
  if (!('serviceWorker' in navigator)) {
    console.warn('当前浏览器不支持Service Worker')
    return
  }

  // 检查是否在开发环境
  const isDevelopment = import.meta.env.DEV
  const swUrl = isDevelopment ? '/dev-sw.js' : '/sw.js'

  try {
    // 在开发环境下，先检查Service Worker文件是否存在
    if (isDevelopment) {
      try {
        const response = await fetch(swUrl, { method: 'HEAD' })
        if (!response.ok) {
          console.warn('开发环境下Service Worker文件不存在，跳过注册')
          return
        }
      } catch (error) {
        console.warn('开发环境下无法访问Service Worker文件，跳过注册:', error)
        return
      }
    }

    wb = new Workbox(swUrl)

    // 监听更新事件（当新SW安装完毕并处于 waiting 状态）
    wb.addEventListener('waiting', () => {
      console.log('Service Worker 等待更新，当前状态:', updatePromptShown)

      // 开发环境下不显示更新提示，避免干扰开发体验
      if (isDevelopment) {
        console.log('开发环境，跳过更新提示')
        wb?.messageSkipWaiting()
        return
      }

      // 防重复：同一页面生命周期内只弹一次
      if (updatePromptShown) {
        console.log('更新提示已显示，跳过重复提示')
        return
      }

      updatePromptShown = true
      console.log('显示更新提示')

      const shouldUpdate = confirm('发现新版本，是否立即更新？')
      if (shouldUpdate) {
        console.log('用户确认更新')
        // 仅当用户确认时，设置一次性刷新标记
        try {
          sessionStorage.setItem(RELOAD_ON_CONTROL_KEY, '1')
        } catch {}
        wb?.messageSkipWaiting()
      } else {
        console.log('用户取消更新')
        // 允许后续再次提示
        updatePromptShown = false
      }
    })

    wb.addEventListener('controlling', () => {
      console.log('Service Worker 正在控制页面')
      
      // 开发环境下不自动刷新页面
      if (isDevelopment) {
        console.log('开发环境，跳过页面刷新')
        updatePromptShown = false
        return
      }

      // 仅当用户之前确认了更新时才刷新一次
      let shouldReload = false
      try {
        shouldReload = sessionStorage.getItem(RELOAD_ON_CONTROL_KEY) === '1'
      } catch {}

      // 重置页面级提示标记
      updatePromptShown = false

      if (shouldReload) {
        try { sessionStorage.removeItem(RELOAD_ON_CONTROL_KEY) } catch {}
        window.location.reload()
      } else {
        console.log('跳过刷新：未检测到用户确认更新标记')
      }
    })

    wb.addEventListener('activated', () => {
      console.log('Service Worker 已激活')
    })

    // 监听安装事件
    wb.addEventListener('installed', (event) => {
      if (event.isUpdate) {
        console.log('Service Worker 已更新')
      } else {
        console.log('Service Worker 已安装')
      }
    })

    await wb.register()
    console.log('Service Worker 注册成功')
  } catch (error) {
    console.error('Service Worker 注册失败:', error)

    // 在开发环境下提供更详细的错误信息
    if (isDevelopment) {
      console.warn('开发环境下Service Worker注册失败是正常的，构建后会在生产环境中正常工作')
    }
  }
}

export const unregisterSW = async () => {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      await registration.unregister()
    }
  }
}